import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4989580b&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=4989580b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989580b",
  null
  
)

component.options.__file = "Home.vue"
export default component.exports